import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { changes } from "src/components/utils/fields";
import { useMediaQuery } from "@mui/material";
import {
  BufferService,
  LoadingContext,
  NavigateContext,
  M_Button,
  M_Fieldset,
  M_Header,
  M_MessageBoard,
} from "src/M_Components";
import { Check, Info, Refresh } from "@mui/icons-material";
import { QuoteInfo } from "./components/QuoteInfo";
import { QuoteDates } from "./components/QuoteDates";
import { QuotePorts } from "./components/QuotePorts";
import { QuoteEntities } from "./components/QuoteEntities";
import { QuoteEquipment } from "./components/QuoteEquiment";
import { QuoteGoods } from "./components/QuoteGoods";
import { QuoteCalculator } from "./components/QuoteCalculator";
import { QuoteCharges } from "./components/QuoteCharges";
import { getLoggedUserEmail } from "./components/QuoteFormField";
import { getQuoteApiErrorMessage } from "./utils/quoteApiError";
import { hasCompany, hasCurrency, hasGoodsDescription, hasGuid, hasValue, buildQuotePayload, getCompanyOptionsFromSession, hydrateGoodsFromQuoteDescription, isValidGuid, normalizeQuoteEquipmentsForSave, normalizeQuoteGoodsForSave, resolveCompanyState, resolveQuoteGoodsDescription } from "./utils/quoteValidation";
import { parseSessionStorageItem } from "./utils/quoteSessionStorage";
import {
  QuoteEquipmentGoodsSection,
  QuoteInfoDatesPortsSection,
} from "./components/QuotePageSections";
import axios from "axios";
import { Print } from "@mui/icons-material";

export const QuoteDetail = ({ roles }) => {
  const [id, setId] = useState(sessionStorage.getItem("selectedTab"));
  const { t } = useTranslation();
  const ctx = useContext(LoadingContext);
  const navigateCtx = useContext(NavigateContext)
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [passedRow, setPassedRow] = useState({});
  const [operation, setOperation] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [triggerAddNewCharge, setTriggerAddNewCharge] = useState(false);
  const [showPageCloseModal, setShowPageCloseModal] = useState(false);

  const accountService = new BufferService("Account");
  // const quoteService = new BufferService("Quote");
  const quoteGetRequestService = new BufferService("quotegetrequest");
  const quoteCreateRequestService = new BufferService("quotecreaterequest");
  const quoteUpdateRequestService = new BufferService("quoteupdaterequest");
  //fetches the details of equipments within the quote 
  const quoteDetailService = new BufferService('QuoteDetail');

  const sessionKeys = ["operation", "data", "open", "passedRow"];

  const matches11 = useMediaQuery("(min-width:970px)");
  const matches12 = useMediaQuery("(min-width:930px)");
  const matches16 = useMediaQuery("(min-width:440px)");

  useEffect(() => {
    if (isFirstTime) {
      ctx.setIsLoad(true);
      getSessionStorageData(id);
      setIsFirstTime(false);
      sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys));
    }
  }, []);

  useEffect(() => {
    const passOperation = ctx.passValue.get("operation");
    setOperation(passOperation);
  }, []);

  useEffect(() => {
    const newId = sessionStorage.getItem("selectedTab");
    if (newId !== id) {
      setId(newId);
      getSessionStorageData(newId);
    }
  }, []);

  useEffect(() => {
    sessionKeys.forEach((key) => {
      sessionStorageMachine(id, key, key);
    });
    // eslint-disable-next-line
  }, [id, operation, data]);

  const sessionStorageMachine = (id, key, value) => {
    if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0)
      return;
    if (eval(value) instanceof String && eval(value) === "") return;
    if (eval(value) instanceof Number && eval(value) === "") return;

    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      sessionStorage.setItem(
        `${id}${key}`,
        JSON.stringify(Array.from(eval(value))),
      );
    } else {
      // eslint-disable-next-line
      const serialized = JSON.stringify(eval(value));
      if (serialized === undefined) return;
      sessionStorage.setItem(`${id}${key}`, serialized);
    }
  };

  const clearQuoteSession = (sessionID) => {
    if (!sessionID) return;
    const normalizedId = String(sessionID).replace(/"/g, "");
    sessionKeys.forEach((key) => {
      sessionStorage.removeItem(`${normalizedId}${key}`);
    });
  };

  const getSessionStorageData = (sessionID) => {
    if (!sessionID) {
      get();
      return;
    }
    ctx.setIsLoad(true);
    const tempO = parseSessionStorageItem(`${sessionID}operation`);
    const tempD = parseSessionStorageItem(`${sessionID}data`);
    const tempOS = parseSessionStorageItem(`${sessionID}open`);
    const tempPR = parseSessionStorageItem(`${sessionID}passedRow`);
    const row = ctx.passValue.get("Row");
    const rowQuoteId = row?.Id;
    const cachedQuoteId = tempD?.id;

    const hasCachedQuoteData =
      tempD &&
      typeof tempD === "object" &&
      Object.keys(tempD).length > 0 &&
      (tempD.id || tempD.quoteCode || tempD.name) &&
      (!rowQuoteId || !cachedQuoteId || cachedQuoteId === rowQuoteId);

    if (hasCachedQuoteData || tempOS || (tempPR && Object.keys(tempPR).length > 0)) {
      if (tempO) setOperation(String(tempO));
      setData(
        resolveCompanyState({
          ...(tempD || {}),
          companyOptions: getCompanyOptionsFromSession(),
        }),
      );
      setOpen(tempOS);
      setPassedRow(tempPR);
      getCompanies();
      ctx.setIsLoad(false);

      return;
    }
    get();
  };

  const functionLeavingPage = () => {
    navigateCtx.closeTab(JSON.parse(id))
  }

  const fixResponseObject = (obj) =>
    Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.charAt(0).toLowerCase() + key.slice(1),
        value,
      ]),
    );

  const fixResponseListObject = (obj) =>
    obj.map((element) =>
      Object.fromEntries(
        Object.entries(element).map(([key, value]) => [
          key.charAt(0).toLowerCase() + key.slice(1),
          value,
        ]),
      ),
    );

  const get = () => {
    const row = ctx.passValue.get("Row")
    const rows = ctx.passValue.get("Rows")

    const pvOperation = ctx.passValue.get("operation")
    if (pvOperation) {
      setOperation(pvOperation)
    }

    const fetchingExistingQuote = (pvOperation === "edit" || pvOperation === 'copyHeader' || pvOperation === 'copyHeaderAndCharges') && row && (!rows || rows.length === 1);

    if (fetchingExistingQuote) {
      const lines = ctx.passValue.get('Row')
      const tempId = lines.Id
      
      quoteGetRequestService.getId(tempId).then((response) => {
        if (response.name === "AxiosError") {
          ctx.toastMessages(
            "error",
            t("Error"),
            response?.response?.data?.Errors || response.message,
          );
          ctx.setIsLoad(false);
          return;
        }

        const fixedQuoteResponse = fixResponseObject(response.Quote);
        const fixedGoodsResponse = pvOperation === 'copyHeader' || pvOperation === 'copyHeaderAndCharges'
          ? []
          : hydrateGoodsFromQuoteDescription(
              fixResponseListObject(response.Goods),
              fixedQuoteResponse,
            );
        const fixedEquipmentResponse = pvOperation === 'copyHeader' || pvOperation === 'copyHeaderAndCharges' ? 
          [] : fixResponseListObject(response.Equipment);
        const fixedChargesResponse = pvOperation === 'edit' || pvOperation === 'copyHeaderAndCharges' ? (response.Charges ? fixResponseListObject(response.Charges) : []) : [];
        const fixedChargesResponseWithId = fixedChargesResponse.map((value, index) => ({ ...value, id: index }))

        delete fixedQuoteResponse.Goods;
        delete fixedQuoteResponse.Equipment;
        delete fixedQuoteResponse.Charges;

        const fixedQuoteResponseDates = {
          ...fixedQuoteResponse,
          startDate: fixedQuoteResponse.startDate?.split("T")[0],
          dueDate: fixedQuoteResponse.dueDate?.split("T")[0],
          expireDate: fixedQuoteResponse.expireDate?.split("T")[0],
        };

        const fixedEquipmentTypesResponse = fixedEquipmentResponse.map(
          (equipment) => ({
            ...equipment,
            equipmentType: `${equipment["equipmentTypeLenght"]}${equipment["equipmentTypeCode"]}`,
          }),
        );

        //this should retreieve the details from the equipment type id quote buffer service
        const fixedDetailsResponse = response.Details 
          ? response.Details.map((element) =>
              Object.fromEntries(
                Object.entries(element).map(([key, value]) => [key.toLowerCase(), value])
              )
            )
          : [];



        const fixedAllResponses = resolveCompanyState({
          ...fixedQuoteResponseDates,
          Goods: fixedGoodsResponse,
          Equipments: fixedEquipmentTypesResponse,
          charges: fixedChargesResponseWithId,
          Details: fixedDetailsResponse,
          companyOptions: getCompanyOptionsFromSession(),
        });
        

        setData(fixedAllResponses);
        changes(
          "counterCharges",
          fixedAllResponses.charges.length,
          setData,
        );

        changes(
          "GoodsCounter",
          fixedAllResponses.Goods.length,
          setData,
        );

        ctx.setIsLoad(false);
      })
        .catch((err) => {
          ctx.toastMessages("error", err.message, "Error");
          ctx.setIsLoad(false);
        });
    } else {
      changes("counterCharges", 0, setData);
      if (ctx.passValue.get("Rows")?.length > 1) {
        setData({ ...data, isMultiEdit: true });
      } else {
        const userEmail = getLoggedUserEmail();
        if (userEmail) {
          changes("createdBy", userEmail, setData);
        }
      }
    }

    changes("totalCurrency", "€", setData);

    getCompanies(fetchingExistingQuote);
    ctx.setIsLoad(false);
  };

  useEffect(() => {
    if (!triggerAddNewCharge) setTriggerAddNewCharge(true);
  }, [data])

  useEffect(() => {
    if (data.clientCode || !data.accountId) return;

    const options = data.companyOptions?.length
      ? data.companyOptions
      : getCompanyOptionsFromSession();
    const match = options.find(
      (c) =>
        String(c.value ?? c.AccountId).toLowerCase() === String(data.accountId).toLowerCase() ||
        String(c.Id).toLowerCase() === String(data.userCompanyId).toLowerCase(),
    );

    if (match) {
      getAccount(match);
    }
  }, [data.accountId, data.clientCode, data.userCompanyId, data.companyOptions?.length]);

  const getCompanies = (skipAutoSelect = false) => {
    let tempCompanies = JSON.parse(sessionStorage.getItem("companies"));
    if (!tempCompanies?.length) {
      ctx.toastMessages("error", "User has no companies!", "");
      return;
    }

    const options = tempCompanies.map((field) => ({
      label: field.Name,
      value: field.AccountId,
      ...field,
    }));

    setData((prev) => {
      const next = resolveCompanyState({ ...prev, companyOptions: options });
      if (!next.clientCode && next.accountId) {
        const match = options.find(
          (c) => String(c.Id).toLowerCase() === String(next.userCompanyId).toLowerCase(),
        );
        if (match) {
          getAccount(match);
        }
      } else if (!skipAutoSelect && options.length === 1 && !hasGuid(next.userCompanyId)) {
        getAccount(tempCompanies[0]);
      }
      return next;
    });
  };

  const getAccount = (companyOrAccountId) => {
    if (!companyOrAccountId) {
      changes("clientCode", "", setData);
      changes("clientName", "", setData);
      changes("clientVat", "", setData);
      changes("userCompanyId", "", setData);
      changes("company", "", setData);
      changes("accountId", "", setData);
      changes("clientId", "", setData);
      return;
    }
    const accountGuid =
      typeof companyOrAccountId === "object"
        ? companyOrAccountId.AccountId ?? companyOrAccountId.value
        : companyOrAccountId;
    const companyUserId =
      typeof companyOrAccountId === "object" && companyOrAccountId.Id
        ? companyOrAccountId.Id
        : null;

    if (companyUserId) {
      changes("userCompanyId", companyUserId, setData);
    }
    if (typeof companyOrAccountId === "object") {
      changes("company", companyOrAccountId.Name || companyOrAccountId.label || "", setData);
      changes("accountId", accountGuid || "", setData);
    }
    accountService.getId(accountGuid).then((res) => {
      if (res.name === "AxiosError") {
        ctx.toastMessages("error", "Couldnt fetch Account!", "");
        return;
      }
      changes("clientCode", res.AccountCode, setData);
      changes("clientName", res.AccountName || "", setData);
      changes("clientVat", res.AccountVATNumber, setData);
      changes("clientId", res.Id || accountGuid, setData);
      if (!companyUserId && res.UserCompanyId) {
        changes("userCompanyId", res.UserCompanyId, setData);
      }
    });
  };

  const validateQuoteCreate = (quoteData = data) => {
    const errors = [];

    const isEdit = operation === "edit" || operation === "EditRequest";
    if (isEdit && !data.isMultiEdit && !hasValue(quoteData.quoteCode)) {
      errors.push(`${t("QuoteCode")} ${t("IsRequired")}`);
    }
    if (!hasValue(quoteData.name)) {
      errors.push(`${t("QuoteName")} ${t("IsRequired")}`);
    }
    if (!hasCurrency(quoteData)) {
      errors.push(`${t("Currency")} ${t("IsRequired")}`);
    }
    if (!hasValue(quoteData.startDate)) {
      errors.push(`${t("StartDate")} ${t("IsRequired")}`);
    }
    if (!hasValue(quoteData.expireDate) && !hasValue(quoteData.dueDate)) {
      errors.push(`${t("ValidTo")} ${t("IsRequired")}`);
    }
    if (!hasGuid(quoteData.loadingPortId)) {
      errors.push(`${t("LoadingPort")} ${t("IsRequired")}`);
    }
    if (!hasGuid(quoteData.dischargePortId)) {
      errors.push(`${t("DischargePort")} ${t("IsRequired")}`);
    }
    if (!hasCompany(quoteData)) {
      errors.push(`${t("Company")} ${t("IsRequired")}`);
    }
    if (!hasGoodsDescription(quoteData)) {
      errors.push(`${t("GoodsDescription")} ${t("IsRequired")}`);
    }
    if (!hasValue(quoteData.remarks)) {
      errors.push(`${t("Remarks")} ${t("IsRequired")}`);
    }

    return errors;
  };

  const onSave = (status) => {
    const normalizedData = resolveCompanyState(data);
    const validationErrors = validateQuoteCreate(normalizedData);
    if (validationErrors.length > 0) {
      const isEdit = operation === "edit" || operation === "EditRequest";
      ctx.toastMessages(
        "error",
        isEdit ? t("ErrorUpdating") : t("ErrorCreating"),
        validationErrors.join("\n"),
      );
      return;
    }

    if (!normalizedData.charges || normalizedData.charges.length === 0) {
      ctx.toastMessages("error", '', t("ChargesRequiredError"));
      return;
    }

    const chargeRequiredFields = [
      { key: 'serviceCode', label: t('ServiceCode') },
      { key: 'currencyCode', label: t('Currency') },
      { key: 'salesValue', label: t('SalesValue') },
      { key: 'multiple', label: t('Multiple') },
      { key: 'goalValue', label: t('Goal') },
    ];

    for (let i = 0; i < normalizedData.charges.length; i++) {
      const charge = normalizedData.charges[i];
      const missing = chargeRequiredFields
        .filter(f => !charge[f.key] && charge[f.key] !== 0)
        .map(f => f.label);
      if (missing.length > 0) {
        ctx.toastMessages("error", '', <span><b>{t('ChargesMissingFields')}</b>: {missing.join(', ')}</span>);
        return;
      }
    }

    const tempCharges = normalizedData.charges?.map((obj) => {
      const { id, ...rest } = obj;
      return {
        ...rest,
        serviceId: rest.serviceId || null,
        currencyId: rest.currencyId || null,
        costCurrencyId: rest.costCurrencyId || null,
        supplierId: rest.supplierId || null,
        costValue: rest.costValue !== '' && rest.costValue != null ? Number(rest.costValue) : 0,
        salesValue: rest.salesValue !== '' && rest.salesValue != null ? Number(rest.salesValue) : 0,
        quantity: rest.quantity !== '' && rest.quantity != null ? Number(rest.quantity) : 0,
      };
    });

    if (!normalizedData.Equipments) normalizedData.Equipments = [];

    const tempEquipments = normalizeQuoteEquipmentsForSave(normalizedData.Equipments || []);

    const tempGoods = normalizeQuoteGoodsForSave(normalizedData.Goods || []);

    const rows = ctx.passValue.get("Rows")

    const quotePayload = buildQuotePayload(normalizedData, {
      status,
      goodsDescription: resolveQuoteGoodsDescription(normalizedData),
    });
    if (!quotePayload.dueDate) {
      quotePayload.dueDate = quotePayload.expireDate || quotePayload.startDate || null;
    }

    const saveData = {
      Equipments: tempEquipments,
      Goods: tempGoods,
      Charges: tempCharges,
      Quote: quotePayload,
      IsMultiEdit: normalizedData.isMultiEdit,
      MultiEditQuoteIds: rows?.map((x) => x.Id),
      CreateRevision: operation === "edit",
    };
      ctx.setIsLoad(true);

    if (operation === "create" || operation === "Request" || operation === 'copyHeader'  || operation === 'copyHeaderAndCharges') {
      quoteCreateRequestService.post(saveData).then((response) => {
        if (response.name === "AxiosError") {
          const apiError = getQuoteApiErrorMessage(response);
          ctx.toastMessages(
            "error",
            t("ErrorCreating"),
            apiError || t("ErrorCreating"),
          );
          ctx.setIsLoad(false);
        } else {
          ctx.toastMessages(
            "success",
            t("Success"),
            t("CreatedQuote"),
          );
          ctx.setIsLoad(false);
          clearQuoteSession(id);
          navigateCtx.closeTab(id.replace(/"/g, ''))
        }
      });
    } else if (operation === "edit" || operation === "EditRequest") {
      quoteUpdateRequestService.update(data.id || rows?.[0]?.Id, saveData).then((response) => {
        if (response.name === "AxiosError") {
          ctx.toastMessages(
            "error",
            t("ErrorUpdating"),
            getQuoteApiErrorMessage(response) || t("ErrorUpdating"),
          );
          ctx.setIsLoad(false);
        } else {
          ctx.toastMessages(
            "success",
            t("Success"),
            t("EditedQuote"),
          );
          ctx.setIsLoad(false);
          clearQuoteSession(id);
          navigateCtx.closeTab(id.replace(/"/g, ''))
        }
      });
    }
  };


  //--------------QUOTE PRINTING SECTION---------------------

  // ─── Constants ───────────────────────────────────────────────────────────────

  const FR_OT_CODES = ["RF", "OT"];

  // ─── Helpers ─────────────────────────────────────────────────────────────────
  //date of quote when printed is the day of the print. 
  const formatValidadeDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d)) return "";
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yy = String(d.getFullYear()).slice(-2);
    return `${dd}.${mm}.${yy}`;
  };

  const getChargeValue = (charges, serviceCode, equipmentTypeId, goalValue = null) => {
    const charge = charges.find(
      (c) =>
        c.serviceCode === serviceCode &&
        (goalValue === null || c.goalValue === goalValue) &&
        (c.restrictionsEquipmentTypeId === equipmentTypeId ||
          c.restrictionsEquipmentTypeId === null)
    );
    return charge?.salesValue ?? "";
  };

  const buildFreightRateGroups = (equipments, charges, currencyCode) => {
    const normalEquipments = (equipments || []).filter(
    (eq) => !FR_OT_CODES.includes(eq.equipmentTypeCode) && !eq.equipmentTypeCode?.endsWith("RF")
    );
    const frOtEquipments = (equipments || []).filter(
      (eq) => FR_OT_CODES.includes(eq.equipmentTypeCode) || eq.equipmentTypeCode?.endsWith("RF")
    );
    const imoSurchargeLines = frOtEquipments.map((eq) => {
      const sizeMatch = eq.equipmentType?.match(/^(\d+)/);  
      const size = sizeMatch ? sizeMatch[1] : eq.equipmentType;
      return {
        location: eq.equipmentType || eq.equipmentTypeCode || '',
        size,
        imoSurcharge: eq.imoSurcharge ?? 0,
        otFrSurchange: eq.otFrSurchange ?? 0,
      };
    });

    const otFrSurcharge = frOtEquipments
      .map((eq) => `${eq.equipmentType}: ${eq.otFrSurchange ?? 0}`)
      .join(" | ");

    const freightRateGroups = normalEquipments.length
        ? [{
            rates: normalEquipments.map((eq) => ({
                containerType: eq.equipmentType || '',
                quantity: eq.quantity      || '',
                currency:currencyCode || '',
                freight:eq.freight ?? '', 
                baf:eq.baf?? '',   
                ets:eq.ets?? '',  
            })),
        }]
        : [];

     const oogRateGroups = frOtEquipments.length
        ? [{
              rates: frOtEquipments.map((eq) => ({
                  containerType: eq.equipmentType || '',
                  quantity:eq.quantity|| '',
                  currency:currencyCode || '',
                  freight:eq.freight ?? '',   
                  baf:eq.baf?? '',   
                  ets:eq.ets?? '',  
                  ses:eq.ses?? '',   
                  oog:eq.oog?? '',   
              })),
          }]
          : [];

      return { freightRateGroups, oogRateGroups, imoSurchargeLines, otFrSurcharge };
    };

  const buildLocalCosts = (equipments, charges, currencyCode) => {
    const localCostColumns = [...new Set(
          (equipments || []).map((eq) => eq.equipmentType).filter(Boolean)
      )];

      const localCosts = [
          { label: "THC",  field: "thc"  },
          { label: "B/L",  field: "bl"   },
          { label: "ISPS", field: "isps" },
          { label: "SELO", field: "seal" },
      ].map(({ label, field }) => ({
          label,
          currency: currencyCode || "",
          values: (equipments || []).map((eq) => eq[field] ?? ""),
      }));

      return { localCostColumns, localCosts };
  };

  const fetchAndMergeEquipmentDetails = async (equipments = []) => {
    if (!equipments.length) return equipments;

    const typeIds = equipments.map((eq) => eq.equipmentTypeId).filter(Boolean);
    if (!typeIds.length) return equipments;

    try {
      const detailResults = await Promise.all(
        typeIds.map((typeId) =>
          quoteDetailService
            .filter(`?$filter=EquipmentTypeId eq ${typeId}`)
            .catch(() => null)
        )
      );

      const detailByTypeId = {};
      detailResults.forEach((res) => {
        if (!res || res.name === 'AxiosError') return;
        const items = res.Items ?? res.items ?? (Array.isArray(res) ? res : []);
        items.forEach((d) => {
          const key = String(d.EquipmentTypeId ?? d.equipmentTypeId ?? '').toLowerCase();
          if (key && !detailByTypeId[key]) detailByTypeId[key] = d;
        });
      });

      return equipments.map((eq) => {
        const d = detailByTypeId[String(eq.equipmentTypeId ?? '').toLowerCase()];
        if (!d) return eq;
        return {
          ...eq,
          freight:d.Freight?? d.freight?? 0,
          baf:d.BAF?? d.baf?? 0,
          ets:d.ETS?? d.ets?? 0,
          ses:d.SES?? d.ses?? 0,
          oog:d.OOG?? d.oog?? 0,
          thc:d.THC?? d.thc?? 0,
          bl:d.BL?? d.bl?? 0,
          isps:d.ISPS?? d.isps?? 0,
          seal:d.Seal?? d.seal?? 0,
          otFrSurchange:d.OtFrSurchange?? d.otFrSurchange?? 0,
          imoSurcharge:d.ImoSurcharge??d.imoSurcharge?? 0,
          cnca:d.CNCA?? d.cnca?? 0,
          cncaPrinted:d.CNCAPrinted?? d.cncaPrinted?? 0,
          dispatch:d.Dispatch?? d.dispatch?? 0,
        };
      });
    } catch (err) {
      console.error('[fetchAndMergeEquipmentDetails] Failed:', err);
      return equipments;
    }
  };

  // ─── Main builder ─────────────────────────────────────────────────────────────

  //for now, we assume that the quote is always approved. In the future, this function can be updated to check the actual approval status of the quote.
  const isQuoteApproved = (quoteData) => true;

  const buildQuotePrintData = (quoteData) => {
    const charges = quoteData.charges || [];
    const equipments = quoteData.Equipments || [];
    const equipmentsWithDetails = equipments;

    const { freightRateGroups, oogRateGroups, imoSurchargeLines, otFrSurcharge } = buildFreightRateGroups(
      equipmentsWithDetails, charges, quoteData.currencyCode
    );
    const { localCostColumns, localCosts } = buildLocalCosts(
      equipmentsWithDetails, charges, quoteData.currencyCode
    );

    return {
      // ── Header info ──────────────────────────────────────────────

      equipmentDetails: equipmentsWithDetails.map((eq) => ({
          containerType:eq.equipmentType || '',
          freight:eq.freight,
          baf:eq.baf,
          ets:eq.ets,
          ses:eq.ses,
          oog:eq.oog,
          thc:eq.thc,
          bl:eq.bl,
          isps:eq.isps,
          seal:eq.seal,
          otFrSurchange:eq.otFrSurchange,
          imoSurcharge:eq.imoSurcharge,
          cnca:eq.cnca,
          cncaPrinted:eq.cncaPrinted,
          dispatch:eq.dispatch,
          currency:quoteData.currencyCode || '',
      })),
      carrierName:quoteData.shipperName || "",
      clientName:quoteData.clientName || "",
      quoteDate:new Date().toLocaleDateString("pt-PT"),
      quoteCode:quoteData.quoteCode || "",
      validade:formatValidadeDate(quoteData.expireDate),

      // ── Route ────────────────────────────────────────────────────
      origin:quoteData.loadingPortName || "",
      destination:quoteData.dischargePortName || "",
      transitTime:quoteData.transitTime || "",
      serviceType:quoteData.serviceType || "",

      // ── Freight rate tables ──────────────────────────────────────
      freightRateGroups,
      oogRateGroups,

      // ── Local costs table ────────────────────────────────────────
      localCostColumns,
      localCosts,

      // ── Surcharge block ──────────────────────────────────────────
      otFrSurcharge,
      imoClasses: [...new Set(
        (quoteData.Goods || [])
          .map((g) => g.dangerousGoodsCode || g.DangerousGoodsCode)
          .filter(Boolean)
      )].join(", ") || "",
      imoSurchargeLines,

      // ── Cancelation fee ──────────────────────────────────────────
      //verificar se cancelation fee são valores hardcoded
      cancelationFeeBefore7Days: "",
      cancelationFeeAfter7Days:  "",


      // ── Goods ────────────────────────────────────────────────────
      goods: (quoteData.Goods || []).map((g) => ({
        description:g.goodsDescription|| g.GoodsDescription|| "",
        commodityCode:g.commodityCode|| g.CommodityCode|| "",
        commodityName:g.commodityName|| g.CommodityName|| "",
        dangerousGoodsCode:g.dangerousGoodsCode|| g.DangerousGoodsCode|| "",
        grossWeight:g.grossWeight?? g.GrossWeight?? "",
        measures:g.measures|| g.Measures|| "",
      })),

      // ── Charges ──────────────────────────────────────────────────
      chargeLines: charges.map((c) => ({
        serviceCode:  c.serviceCode  || "",
        serviceName:  c.serviceName  || "",
        currency:     c.currencyCode || "",
        salesValue:   c.salesValue   ?? "",
        costValue:    c.costValue    ?? "",
        quantity:     c.quantity     ?? "",
        multiple:     c.multiple     || "",
        goal:         c.goal         || "",
        supplier:     c.supplierCode || "",
        restrictions: c.restrictionsEquipmentType
          ? `${c.restrictionsSize || ""}${c.restrictionsEquipmentType}`
          : "",
      })),

      // ── Totals ───────────────────────────────────────────────────
      totals: (() => {
        const totalCost  = charges.reduce((sum, c) => sum + (Number(c.costValue)  || 0), 0);
        const totalSales = charges.reduce((sum, c) => {
          const qty = c.multipleValue === 'Q' ? Number(c.quantity) || 1 : 1;
          return sum + (Number(c.salesValue) || 0) * qty;
        }, 0);
        const profit = (totalSales - totalCost).toFixed(2);
        const markup = totalCost > 0
          ? (((totalSales - totalCost) / totalCost) * 100).toFixed(2)
          : "0.00";
        return {
          totalCharges: charges.filter(c => c.serviceCode !== '').length,
          totalCost:    `${totalCost.toFixed(2)} ${quoteData.currencyCode || ''}`,
          totalSales:   `${totalSales.toFixed(2)} ${quoteData.currencyCode || ''}`,
          profit:       `${profit} ${quoteData.currencyCode || ''}`,
          markup:       `${markup} %`,
        };
      })(),

      // ── Other ────────────────────────────────────────────────────
      moeda:quoteData.currencyCode || "",
      remarks:quoteData.remarks || "",

      
    };
  };

  const printQuoteDocument = async () => {
    ctx.setIsLoad(true);
    try {
      const enrichedEquipments = await fetchAndMergeEquipmentDetails(data.Equipments || []);
      const printData = buildQuotePrintData({ ...data, Equipments: enrichedEquipments });

      const payload = {
        templateName: "QuoteTemplate",
        synchronous: true,
        data: printData,
      };

      const quotePrintService = new BufferService("Quote/print", "Quote");
      const url = quotePrintService.url + quotePrintService.entityName;
      const response = await axios.post(url, payload, { responseType: "blob" });

      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        ? contentDisposition.split("filename=")[1]?.replace(/"/g, "").trim()
        : "Quote Document";

      const blob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const printWindow = window.open("", fileName);
      printWindow.document.write(`
        <html>
          <head><title>${fileName}</title></head>
          <body style="margin:0; padding:0;">
            <iframe
              id="pdfFrame"
              src="${blobUrl}"
              style="width:100%; height:100vh; border:none;"
            ></iframe>
            <script>
              document.getElementById('pdfFrame').onload = function() {
                setTimeout(function() {
                  this.contentWindow.print();
                }.bind(this), 500);
              };
            <\/script>
          </body>
        </html>
      `);
      printWindow.document.close();
      ctx.setIsLoad(false);
    } catch (error) {
      console.error("[printQuoteDocument] Failed:", error);
      ctx.setIsLoad(false);
    }
  };

  return (
    <div>
      <M_Header
        element={
          <>
            <M_Button
              tooltip={t("Back")}
              label={t("Back")}
              icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
              onClick={() => { setShowPageCloseModal(true) }}
            />
            <M_Button
              tooltip={t("LabelSubmitForApproval")}
              icon={<Check />}
              label={t("LabelSubmitForApproval")}
              onClick={() => onSave("W")}
            />
            {isQuoteApproved(data) && (
              <M_Button
                tooltip={t("Print")}
                icon={<Print />}
                label={t("Print")}
                onClick={printQuoteDocument}
              />
            )}
          </>
        }
      />
      <div style={{ margin: "20px" }}>
        {data.isMultiEdit && (
          <M_Fieldset
            labelInside
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "25px",
                  marginLeft: "10px",
                }}
              >
                <Info style={{ marginRight: "10px", scale: "1.3" }} />{" "}
                {t("MultiEditInfoTitle")}
              </div>
            }
            elements={<div>{t("MultiEditInfoContent")}</div>}
          />
        )}
        {data.bookingId !== null && data.bookingId !== undefined && (
          <M_Fieldset
            labelInside
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "25px",
                  marginLeft: "10px",
                }}
              >
                <Info style={{ marginRight: "10px", scale: "1.3" }} />{" "}
                {t("QuoteHasBookingCreatingNewTitle")}
              </div>
            }
            elements={<div>{t("QuoteHasBookingCreatingNewBody")}</div>}
          />
        )}
        <QuoteInfoDatesPortsSection
          wide={matches11}
          quoteInfo={<QuoteInfo dataState={data} setDataState={setData} editMode={operation === "edit"} remarksRequired />}
          dates={<QuoteDates dataState={data} setDataState={setData} hideDueDate />}
          ports={<QuotePorts dataState={data} setDataState={setData} />}
        />
        <div>
          <QuoteEntities dataState={data} setDataState={setData} />
        </div>
        <QuoteEquipmentGoodsSection
          wide={matches12}
          equipment={<QuoteEquipment dataState={data} setDataState={setData} />}
          goods={<QuoteGoods dataState={data} setDataState={setData} />}
        />
        <QuoteCharges
          dataState={data}
          setDataState={setData}
          passedRowState={passedRow}
          setPassedRowState={setPassedRow}
          triggerAddNewCharge={triggerAddNewCharge}
        />
        <div style={{ margin: "25px" }}></div>
        <QuoteCalculator dataState={data} setDataState={setData} />
      </div>
      <M_MessageBoard
        warning
        open={showPageCloseModal}
        onClose={() => setShowPageCloseModal(false)}
        title={t("leavingPageTitle")}
        body={t("leavingPageBody")}
        footer={
            <span style={{ display: 'flex', alignItems: 'center' }}>
                <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setShowPageCloseModal(false)} label={t("ButtonCancel")} />
                <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={functionLeavingPage} label={t("ButtonConfirm")} />
            </span>
        }
      />
    </div>
  );
};
